import { useState } from 'react';
import AdminSidebar from '../../components/AdminSidebar';
import { adminChangePassword } from '../../lib/adminApi';

const ORANGE = '#F37428';
const NAVY   = '#0a2540';

export default function ChangePassword() {
  const [current,  setCurrent]  = useState('');
  const [next,     setNext]     = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [saving,   setSaving]   = useState(false);
  const [success,  setSuccess]  = useState(false);
  const [error,    setError]    = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setSuccess(false);
    if (next !== confirm) { setError('New passwords do not match'); return; }
    if (next.length < 8)  { setError('New password must be at least 8 characters'); return; }
    setSaving(true);
    try {
      const r = await adminChangePassword(current, next);
      if (r?.ok) {
        setSuccess(true);
        setCurrent(''); setNext(''); setConfirm('');
      } else {
        setError(r?.error || 'Failed to change password');
      }
    } catch (err) {
      setError(err?.message || 'Request failed');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f0f5fb', fontFamily: "'Inter', system-ui, sans-serif" }}>
      <AdminSidebar active="change-password" />
      <main style={{ flex: 1, padding: '40px 48px', maxWidth: 520 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: NAVY, marginBottom: 6 }}>Change Password</h1>
        <p style={{ color: '#64748b', fontSize: 13, marginBottom: 28 }}>Update your admin account password.</p>

        <div style={{ background: '#fff', borderRadius: 12, padding: 28, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <form onSubmit={handleSubmit}>
            <label style={s.label}>Current Password</label>
            <input
              type="password" value={current} onChange={e => setCurrent(e.target.value)}
              required autoComplete="current-password" style={s.input}
            />

            <label style={s.label}>New Password</label>
            <input
              type="password" value={next} onChange={e => setNext(e.target.value)}
              required autoComplete="new-password" placeholder="Minimum 8 characters" style={s.input}
            />

            <label style={s.label}>Confirm New Password</label>
            <input
              type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
              required autoComplete="new-password" style={{ ...s.input, marginBottom: 20 }}
            />

            {error   && <div style={s.error}>{error}</div>}
            {success && <div style={s.success}>Password changed successfully.</div>}

            <button type="submit" disabled={saving || !current || !next || !confirm} style={s.btn}>
              {saving ? 'Saving…' : 'Change Password'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}

const s = {
  label:   { display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, marginTop: 14 },
  input:   { width: '100%', padding: '8px 10px', borderRadius: 7, border: '1px solid #d1d5db', fontSize: 13, outline: 'none', boxSizing: 'border-box' },
  btn:     { marginTop: 4, background: ORANGE, color: '#fff', border: 'none', borderRadius: 8, padding: '9px 22px', fontWeight: 600, fontSize: 13, cursor: 'pointer', opacity: 1 },
  error:   { background: '#fef2f2', border: '1px solid #fca5a5', color: '#b91c1c', borderRadius: 7, padding: '8px 12px', fontSize: 12, marginBottom: 12 },
  success: { background: '#f0fdf4', border: '1px solid #86efac', color: '#15803d', borderRadius: 7, padding: '8px 12px', fontSize: 12, marginBottom: 12 },
};
